const es = {
  sinObra: "Sin obra",
  cat: { materiales: "Materiales", mano_obra: "Mano de obra", subcontratas: "Subcontratas", suministros: "Suministros", fiscal: "Fiscal / Impuestos" },
  rama: {
    albanil_oficial: "Albañil oficial", fontanero: "Fontanero", electricista: "Electricista", carpinteria_madera: "Carpintería madera",
    carpintero_aluminio: "Carpintero aluminio", gestion_residuos: "Gestión de residuos", transportes: "Transportes",
    peones: "Peones / Ayudantes", gestiones_comerciales: "Gestiones comerciales",
  },
  exento: { si: "Exento", marcar: "Marcar exento", marcado: "Gasto marcado como exento", quitado: "Gasto sin marca de exento", error: "No se pudo actualizar el gasto" },
  toast: {
    subida: "Imagen subida", leyendo: "Imagen subida · leyendo datos de la factura…", leidos: "Datos de la factura leídos automáticamente ✨",
    noLeidos: "No se pudieron leer los datos automáticamente. Complétalos a mano.", errorSubir: "No se pudo subir la imagen",
    registrado: "Gasto registrado", eliminado: "Gasto eliminado",
  },
  jornada: {
    titulo: "Control de jornada por obra (límite {{n}}h/semana)", totales: "{{n}}h totales",
    excesoObras: "{{n}} obra(s)", excesoTexto: "superan las {{n}}h semanales de mano de obra. Revisa la carga de trabajo.",
    vacio: "Aún no hay horas de mano de obra registradas. Añade un gasto de categoría «Mano de obra» indicando la obra y las horas.",
    semExcedidas: "{{n}} sem. excedida(s)", resumen: "{{h}}h · {{n}} semana(s)", excesoSemana: "Exceso de {{h}}h sobre el límite legal de {{n}}h.",
  },
  coste: { titulo: "Coste por obra", ver: "Ver Obras / Proyectos →", obra: "Obra", materiales: "Materiales", manoObra: "Mano de obra", total: "Coste total" },
  vacio: { titulo: "Sin gastos", hint: "Registra facturas de materiales, mano de obra y subcontratas" },
  tabla: { concepto: "Concepto", categoria: "Categoría", fecha: "Fecha", horas: "Horas", total: "Total", justificante: "justificante", justificanteM: "Justificante" },
  form: {
    escanea: "Escanea tu factura y rellenamos los datos", quitar: "Quitar imagen", leyendo: "Leyendo…", camara: "Escanear con cámara",
    subir: "Subir archivo", analizando: "Analizando imagen…",
    ocrBloqueado: "Puedes adjuntar la imagen; la lectura automática con IA está disponible desde el Plan Trimestral.",
    concepto: "Concepto", categoria: "Categoría", proveedor: "Proveedor / Empresa", base: "Base (€)", impuesto: "Impuesto",
    obra: "Obra / Proyecto", irpf: "Retención IRPF (profesionales)", sinRetencion: "Sin retención",
    isp: "Inversión del sujeto pasivo", ispNota: "(subcontrata de obra que te factura sin IVA ni IGIC)",
    exento: "Exento de impuesto", exentoNota: "(seguros, tasas, alquiler de vivienda…)",
    horas: "Horas", rama: "Rama de actividad", datosFactura: "Datos de la factura", numero: "Nº de factura", hora: "Hora de compra",
    nif: "NIF / CIF empresa", registro: "Nº registro mercantil", opcional: "Opcional", fecha: "Fecha",
  },
};

export default es;
